import { render, staticRenderFns } from "./Coproff_Navbar.vue?vue&type=template&id=2d710306&scoped=true"
import script from "./Coproff_Navbar.vue?vue&type=script&lang=js"
export * from "./Coproff_Navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d710306",
  null
  
)

export default component.exports